module.exports = __webpack_public_path__ + "img/update-icon.5f2d1e6b.svg";